import {
  Area,
  AreaChart,
  Brush,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import {
  ChartCard,
  ChartNoDataFound,
  ChartsTooltip,
  formatDate,
  formatNumber,
  formatTime,
  useEffect,
  useState,
} from "@";
import { useOrdersQuery } from "../utils/queries.js";

// Main component to render the AreaChart
const Index = () => {
  const [searchDuration, setSearchDuration] = useState(3);
  const [dataObject, setDataObject] = useState([]);
  const { data } = useOrdersQuery(searchDuration);

  // Fetch data based on the duration
  const formatData = async () => {
    const formatKey = (timestamp) => {
      if (searchDuration == 0) {
        return formatTime(timestamp);
      }
      return formatDate(timestamp);
    };

    const values = data?.map((item) => ({
      date: formatKey(item?.date),
      amount: Math.ceil(item?.amount),
    }));

    const allValuesZero = (data) => data?.every((item) => item.amount === 0);

    setDataObject(allValuesZero(values) ? [] : values);
  };

  useEffect(() => {
    formatData(searchDuration);
  }, [searchDuration, data]);

  return (
    <ChartCard
      title="إجمالي التبرعات"
      searchDurationUpdated={(value) => setSearchDuration(value)}
      className="mb-5 print:hidden"
    >
      <div className="mt-3 h-96">
        {dataObject?.length > 0 ? (
          <ResponsiveContainer
            width="100%"
            height="100%"
            style={{ direction: "ltr" }}
          >
            <AreaChart margin={{ top: 10, left: 30 }} data={dataObject}>
              <XAxis minTickGap={10} fontSize={11} dataKey="date" />
              <CartesianGrid
                className="stroke-gray-200 dark:stroke-gray-600"
                strokeDasharray="3 3"
              />
              <YAxis
                tickFormatter={(value) => formatNumber(value)}
                fontSize={11}
              />

              {/* <Brush /> */}
              <Brush height={30} stroke="#aaa" dataKey="date" />

              <Tooltip content={<ChartsTooltip />} />
              <defs>
                <linearGradient
                  id="colorDonationBlue"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="0%" stopColor="#57009466" />
                  <stop offset="100%" stopColor="#4E1AC7" stopOpacity={0} />
                </linearGradient>
              </defs>
              <Area
                type="monotone"
                dataKey="amount"
                strokeWidth={2}
                stroke="#4E1AC7"
                fill="url(#colorDonationBlue)"
              />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <ChartNoDataFound />
        )}
      </div>
    </ChartCard>
  );
};

export default Index;
